import { Dictionary } from "../types";

export const dictionaries: Dictionary[] = [
  {
  // English dictionary (index 0)
    ph: {
      registration: "Quick registration",
      total: "TOTAL",
      create: "Create",
      event_o: "Opened events",
      event_p: "Past events",
      event_c: "Create event",
      event_t: "Enter a title (Game Night/Mini Cup)",
      prtcp: "PARTICIPANTS",
      gamescaps: "GAMES",
      gamecaps: "GAME",
      event_pa: "EVENT PAGE",
      killed: "Killed",
      in: "On site",
      reopen: "Re-open",
      games: "Games",
      cgname: "game",
      copylink: "Copy",
      startclub: "START A NEW GAME",
      pwarning:
        "You are not a referee in this tournament - all changes will not be send to server!",
      swarning:
        "Are you sure you want to submit results to server? The screen will close. Please be aware that you will be redirected back to home screen after successfull submission!",
      rwarning:
        "You are trying to update game results - it will only updae bonuses, penalties and comment. In case yu need another updates, please re-enter the entire game!",
      stage: "Stage",
      start: "Start",
      delete: "Delete",
      table: "Table",
      session: "Session",
      back: "← Back",
      noseats:
        "Seats weren't generated yet or tournamebt is already closed.",
      none: "none",
      voting: "Voting",
      cselerror:
        "You should select the club, to moderate the game. Are you sure your club is supported and listed? Try to synchronise data again.",
      dph: "Day",
      nph: "Night",
      resph: "Results",
      sclub: "Your clubs",
      players: "Players",
      citydec: "What does city decide",
      execall: "Execute all",
      vanga: "has to guess mafias and testament",
      lms: "has a testament",
      skip: "Skip",
      confirm: "Confirm",
      plgot4f: "Player has received 4 fauls",
      rcnt: "Reset fauls",
      plgot3f: "Player got 3rd foul and will not speak",
      tday: "this day",
      nday: "next day",
      novoting: "One player nominated, the night comes to the city",
      bye1player: "One player nominated, player",
      bye1player2: "leaves the game",
      exec: "Execute",
      mmenu: "Main menu",
      logout: "Logout",
      close: "Close",
      morning: "Morning",
      btday: "Back to day",
      cancelgame: "Cancel game",
      ppk: "Opposite team wins",
      disqualify: "Disqualify",
      ppkred: "Citizens won caused by player number:",
      ppkblack: "Mafia won caused by player number:",
      chooseact: "Please choose the action",
      loadall: "Load all tournaments",
      roles: "Roles",
      hroles: "Hide roles",
      gngt: "Go night",
      confirm_cancel_game: "Confirm game cancellation?",
      confirm_cancel_game_message: "Are you sure you want to cancel the game? All progress will be lost.",
      confirm_go_night: "Confirm transition to night?",
      confirm_go_night_message: "Are you sure you want to proceed to night without voting? The voting phase will be skipped.",
      confirm_back_to_day: "Confirm return to day?",
      confirm_back_to_day_message: "Are you sure you want to return to the day phase? Night phase progress will be lost.",
      yes_cancel: "Yes, cancel",
      yes_proceed: "Yes, proceed",
      yes_return: "Yes, return",
      disqualification_warning_title: "Disqualification Alert",
      disqualification_warning_message: "According to game rules, voting should be cancelled this day due to a player disqualification in the current or previous phase.",
      skip_voting_go_night: "Skip voting and go to night",
      vote_anyway: "Vote anyway",
      fls: "Fauls",
      sroles: "Show roles",
      upnow: "Upload now",
      save: "Save",
      don: "Don",
      maf: "Mafia",
      shrf: "Sheriff",
      fblood: "First victim",
      lh: "Best bet",
      na: "Not applicable",
      lorder: "Leave order",
      otstr: "Shooting",
      donchk: "Don checks",
      shchk: "Sheriff checks",
      logedas: "You logged in as ",
      ctwon: "Citizens won",
      mafwon: "Mafia won",
      draw: "Draw",
      upfail: "Uploading has failed, data is saved, please try again",
      plsactivate:
        "Please activate your account via the link in email and login",
      player: "Player",
      isdup: "is duplicating",
      pwd: "Password",
      cncl: "Cancel",
      nxt: "Next",
      srch: "Search",
      nrate: "Non-ranked",
      yrate: "Ranked",
      rdy: "Ready",
      pwlength: "Password should consist of 3-100 symbols",
      header: " Mafia App",
      submit: "Submit",
      login: "Login",
      loading: "Loading",
      adding_players: "Player seating",
      intro_n: "Intro night",
      juComment: "Description of bonuses and penalties",
      juCommentDef: "Information was not filled",
      juError:
        "Judge wasn't assigned to the table on website, please fix it and retry loading the game!",
      j: "JU",
      g_a: "Add.",
      g_p: "Pen.",
      g_dp: "D.P.",
      restoreGameMsg: "Continue unfinished game?",
      toggle_timer: "Toggle timer",
      reset_timer: "Reset timer",
      technical_break: "Technical break",
      technical_break_title: "Technical Break",
      technical_break_message: "The game is on a technical break. Close this window to continue.",
      stream_connection_error: "Network error: Check your internet connection. Stream may not be updating.",
      // Login page
      welcome_subtitle: "Welcome back to the MWT game management",
      email_label: "Email",
      email_placeholder: "you@example.com",
      password_placeholder: "••••••••",
      choose_language: "Choose your language",
      lang_english: "English",
      lang_russian: "Русский",
      lang_ukrainian: "Українська",
      lang_georgian: "ქართული",
      lang_hebrew: "עברית",
      login_meta: "Use your Mafia World Tour credentials to access the control panel.",
      login_failed: "Login failed",
      network_error: "Network error",
      // Last Words
      last_words: "Last Words",
      voted_out: "was voted out by the city",
      eliminated_night: "was eliminated during the night",
      final_speech: "has the opportunity to give their final speech before leaving the game.",
      player_of: "Player {0} of {1}",
      instructions: "Instructions:",
      allow_speech: "Allow the eliminated player to give their final speech",
      share_thoughts: "The player can share their thoughts, suspicions, or strategy",
      click_continue: "Click \"{0}\" when the speech is complete",
      multiple_eliminated: "Multiple players were eliminated - each gets their turn",
      goodbye: "Goodbye",
      undo_vote: "Undo",
      back_to_night: "Back to night",
      continue_game: "Continue Game",
      next_player: "Next Player",
      // Role Assignment
      citizens: "Citizens",
      citizen: "Citizen",
      mafia: "Mafia",
      instructions_roles: "Click on role icons to change player roles",
      required_roles: "Required: 6 Citizens, 2 Mafia, 1 Don, 1 Sheriff",
      hide_roles_instruction: "Use \"Hide roles\" button to hide role assignments from players",
      click_ready: "Click \"Ready\" when all roles are correctly assigned",
      invalid_distribution: "Invalid role distribution!",
      current_distribution: "Current: {0} Citizens, {1} Mafia, {2} Don, {3} Sheriff",
      // Tournament Seats
      loading_seats: "Loading tournament seats...",
      tournament_seating: "Tournament seating",
      select_session: "Select a session to start entering game results",
      no_seats_available: "No seats available",
      failed_load_seats: "Failed to load tournament seats",
      seats_not_generated: "Seats haven't been generated yet or the tournament is already closed.",
      // Game Results
      game_in_progress: "Game in progress",
      search_judge: "Search judge...",
      game_description: "Game description...",
      search_penalties: "Search penalties...",
      judge_label: "Judge",
      description_label: "Description",
      penalty_value: "Penalty: {0}",
      game_statistics: "Game Statistics",
      game_timing: "Game Timing",
      start_time: "Start",
      end_time: "End",
      nights_count: "Nights",
      // Main Menu
      mafia_app: "Mafia App",
      refresh: "Refresh",
      select_club: "Select club",
      tournament_region_flag: "Tournament region flag",
      main_menu_subtitle: "Select a tournament or club to manage your next game.",
      club_section_description: "Jump straight into your club events and launch a new game.",
      club_card_meta: "Explore events, frequent players, and schedules",
      open_club: "Open club",
      no_clubs_synced: "No clubs synced yet. Refresh or check your account permissions.",
      tournaments_heading: "Tournaments",
      tournament_section_description: "Browse official events and open the seating chart for your table.",
      tournament_card_meta: "Tap to view seating and participants",
      view_seats: "View seats",
      no_tournaments: "No tournaments are available right now. Refresh later to sync the latest events.",
      profile_title: "Profile",
      profile_aria_label: "Profile",
      club_logo_alt: "{0} logo",
      // Game Actions
      select_disqualify: "Select the player to disqualify from the game:",
      select_ppk: "Select the player who caused the opposite team to win:",
      action_label: "Action:",
      note_label: "Note:",
      ppk_note:
        "PPK (Opposite team wins) is used when a player's actions directly cause their team to lose the game. The opposing team will be declared the winner.",
      // Player Setup
      add_guest: "Add guest player",
      judge_avatar_alt: "Judge avatar",
      player_avatar_alt: "{0} avatar",
      guest_player_label: "Guest {0}",
      level_short: "Lvl {0}",
      // Day Phase
      first_day: "First Day",
      day_number: "Day {0}",
      first_speaker: "First speaker:",
      nomination_order: "Nomination order: {0}",
      nomination_title: "Player {0} Nomination",
      nomination_prompt: "Choose a player to nominate for elimination",
      player_eliminated_tooltip: "Player {0} is eliminated",
      player_already_nominated: "Player {0} already nominated",
      nominate_player: "Nominate player {0}",
      current_nomination: "Current nomination: Player {0}",
      clear_nomination: "Clear nomination",
      unknown: "Unknown",
      vs: "VS",
      day_instructions_title: "Day Phase Instructions",
      day_instruction_discuss: "Players discuss and nominate suspects",
      day_instruction_vs: "Use the VS button to open the nomination selector",
      day_instruction_disabled: "Eliminated and already nominated players are disabled",
      day_instruction_fouls: "Click foul badges to issue penalties",
      day_instruction_voting: "Start voting when nominations are prepared",
      day_instruction_skip: "Use Go Night to skip directly to the night phase",
      current_nominations_title: "Current Nominations",
      nomination_item: "{0} nominates {1}",
      // Club Events
      enter_event_title: "Please enter an event title",
      failed_create_event: "Failed to create event",
      confirm_remove_participant: "Are you sure you want to remove this participant?",
      loading_participants: "Loading participants...",
      actions: "Actions",
      confirm_delete_game: "Are you sure you want to delete this game?",
      confirm_close_event: "Are you sure you want to close this event?",
      confirm_open_event: "Are you sure you want to reopen this event?",
      confirm_delete_event: "Are you sure you want to delete this event?",
      event_ranking: "Event ranking",
      failed_update_event_ranking: "Failed to update event ranking",
      event_title_label: "Title",
      event_date_label: "Date",
      event_time_label: "Time",
      event_description_label: "Description (Optional)",
      event_description_placeholder: "Event description...",
      event_exists_warning: "An event already exists on this date. Do you want to create another one?",
      creating: "Creating...",
      club_prefix: "Club: {0}",
      more_events: "... ({0} more)",
      yes: "Yes",
      no: "No",
      // Night Actions
      select_shooting_target: "Select target for night shooting:",
      miss: "Miss",
      don_dead_skip: "Don is dead - check skipped",
      select_don_check: "Select player for Don's check:",
      next: "Next →",
      sheriff_dead_skip: "Sheriff is dead - check skipped",
      select_sheriff_check: "Select player for Sheriff's check:",
      check_player: "Check player {0}",
      player_dead: "Player {0} is dead",
      step_shooting: "Shooting",
      step_don: "Don",
      step_sheriff: "Sheriff",
      stage_1_shooting: "Stage 1: Night shooting",
      stage_2_don: "Stage 2: Don's check",
      stage_3_sheriff: "Stage 3: Sheriff's check",
      // Morning Transition
      no_night_eliminations: "No one was eliminated during the night.",
      continue_to_day: "Continue to Day",
      continue_to_day_number: "Continue to Day {0}",
      first_victim_note: "First victim – can guess mafia members",
      select_mafia_prompt: "Select up to 3 players you think are mafia:",
      last_words_note: "Last words before leaving the game",
      best_move_unavailable: "Best move unavailable:",
      first_day_eliminations: "{0} players were eliminated on the first day (≥2)",
      // Voting
      no_nominations_title: "No Nominations",
      no_nominations_desc: "No players were nominated for elimination.",
      single_nomination: "Only one player was nominated: {0}",
      player_will_be_eliminated: "{0} will be eliminated.",
      tie_repeat_info:
        "After the revote, the number of players with equal votes did not change.",
      tie_exceeds_limit_warning: "Executing all {0} players exceeds the limit!",
      tie_execute_tooltip: "Execute all {0} players",
      tie_execute_limit_tooltip: "Cannot execute {0} players (limit: {1})",
      shootout_round: "Shootout Round {0}",
      candidate_progress: "Candidate {0} of {1} | Votes remaining: {2}",
      candidate_receives_remaining:
        "Player #{0} receives all remaining votes: {1}",
      finish_voting: "Finish voting",
      all_remaining_votes: "All remaining votes",
      tied_players: "Players with equal votes:",
      rule_50_percent: "50% Rule:",
      cannot_execute_more: "Cannot execute more than {0} players (50% of {1} alive players).",
      three_way_tie_rule: "3 out of 9 Rule",
      cannot_execute_three_way_tie: "According to game rules, all 3 players cannot be executed when there are exactly 9 players alive and votes are tied between 3 candidates. You must either cancel voting or proceed to night.",
      select_action: "Select action:",
      current_results: "Current results:",
      // Penalty section
      penalty_section: "sec.{0}",
      foul_four_heading: "4th Foul Penalty:",
      foul_four_instructions:
        "You must choose what happens to this player. This decision cannot be skipped.",
      foul_three_heading: "3rd Foul Penalty:",
      foul_three_instructions:
        "You must choose when this player cannot speak. This decision cannot be skipped.",
      // Stream settings
      stream_settings: "Streaming settings",
      stream_theme_label: "Stream theme",
      stream_language_label: "Stream language",
      theme_classic: "Classic",
      theme_dark: "Dark",
      theme_noroles: "Without roles",
      theme_cartel: "Cartel",
      theme_xcity: "X-City",
      settings_button: "Settings",
      app_language_label: "App language",
    },
  },
  // Russian dictionary (index 1)
  {
    ph: {
      registration: "Быстрая регистрация",
      total: "ВСЕГО",
      create: "Создать",
      event_o: "Активные мероприятия",
      event_p: "Прошедшие мероприятия",
      event_c: "Создать новое мероприятие",
      event_t: "Введите название (Игровой вечер/Мини кап)",
      prtcp: "УЧАСТНИКИ",
      gamescaps: "ИГРЫ",
      gamecaps: "ИГРА",
      event_pa: "СТРАНИЦА МЕРОПРИЯТИЯ",
      killed: "ПУ",
      in: "На месте",
      reopen: "Переоткрыть",
      games: "Игры",
      cgname: "игра",
      copylink: "Скопировать",
      startclub: "НАЧАТЬ НОВУЮ ИГРУ",
      pwarning:
                  "Вы не являетесь судьей данного турнира - все изменения не будут отправлены на сервер!",
      swarning:
                  "Вы уверены, что хотите отправить изменения на сервер? Экран введенных данных закроется. Пожалуйста будьте в курсе, что после успешной отправки результатов вы автоматически будете перенаправлены на главный экран!",
      rwarning:
                  "Вы пытаетесь обновить игру - это только обновление допов, штрафов и комментария. Если вам необходимо обновить что-то другое, пожалуйста перевведите всю игру целиком!",
      stage: "Этап",
      start: "Начать",
      delete: "Удалить",
      table: "Стол",
      session: "Тур",
      back: "← Назад",
      noseats:
          "Рассадка еще не создана или турнир уже закрыт.",
      none: "нет",
      voting: "Голосование",
      cselerror:
          "Вы должны выбрать клуб, чтоб проводить игру. Вы уверены, что ваш клуб поддерживается системой? Попробуйте синхронизировать данные.",
      dph: "Дневная фаза",
      nph: "Ночая фаза",
      resph: "Результаты",
      sclub: "Ваши клубы",
      players: "Игроки",
      citydec: "Решение города",
      execall: "Казнить всех",
      vanga: "угадывает мафию",
      lms: "говорит завещание",
      skip: "Пропустить",
      confirm: "Подтвердить",
      plgot4f: "Игрок получил 4 фола",
      rcnt: "Сброс фолов",
      plgot3f: "Игрок получил 3-й фол и не будет говорить",
      tday: "этот день",
      nday: "след. день",
      novoting: "Был выствлен один игрок, в городе ночь",
      bye1player: "Один игрок был выставлен, игрок",
      bye1player2: "покидает игру",
      exec: "Казнить",
      mmenu: "Главное меню",
      logout: "Выход",
      close: "Закрыть",
      morning: "Утро",
      btday: "Назад в день",
      cancelgame: "Отменить игру",
      ppk: "ППК",
      disqualify: "Дисквал-ть",
      ppkred: "Мирные победили из-за игрока номер:",
      ppkblack: "Мафия победила из-за игрока номер:",
      chooseact: "Действия",
      loadall: "Загрузить все турниры",
      roles: "Роли",
      hroles: "Скрыть роли",
      gngt: "В ночь",
      confirm_cancel_game: "Подтвердить отмену игры?",
      confirm_cancel_game_message: "Вы уверены, что хотите отменить игру? Весь прогресс будет потерян.",
      confirm_go_night: "Подтвердить переход в ночь?",
      confirm_go_night_message: "Вы уверены, что хотите перейти в ночь без голосования?",
      confirm_back_to_day: "Подтвердить возврат в день?",
      confirm_back_to_day_message: "Вы уверены, что хотите вернуться в дневную фазу? Прогресс ночной фазы будет потерян.",
      yes_cancel: "Да, отменить",
      yes_proceed: "Да, перейти",
      yes_return: "Да, вернуться",
      disqualification_warning_title: "Отмена голосования",
      disqualification_warning_message: "По правилам ФИИМ голосование в этот день отменяется из-за дисквалификации игрока в текущей или предыдущей фазе.",
      skip_voting_go_night: "В ночь",
      vote_anyway: "Голосовать всё равно",
      fls: "Фолы",
      sroles: "Показать роли",
      upnow: "Загрузить сейчас",
      save: "Сохранить",
      don: "Дон",
      maf: "Мафия",
      shrf: "Шериф",
      fblood: "Первая жертва",
      lh: "Лучший ход",
      na: "Не применимо",
      lorder: "Порядок ухода",
      otstr: "Отстрел",
      donchk: "Проверки дона",
      shchk: "Проверки шерифа",
      logedas: "Вы вошли как ",
      ctwon: "Мирные победили",
      mafwon: "Мафия победила ",
      draw: "Ничья",
      upfail: "Загрузка не удалась, данные сохранены, попробуйте снова",
      plsactivate:
          "Пожалуйста, активируйте свой аккаунт через email и войдите в систему",
      player: "Игрок",
      isdup: "дублируется",
      pwd: "Пароль",
      cncl: "Отмена",
      nxt: "Далее",
      srch: "Поиск",
      nrate: "Нерейтинговое",
      yrate: "Рейтинговое",
      rdy: "Готово",
      pwlength: "Пароль должен содержать 3–100 символов",
      header: " Mafia App",
      submit: "Войти",
      login: "Вход",
      loading: "Загрузка",
      adding_players: "Рассадка игроков",
      intro_n: "Раздача и договорка",
      juComment: "Описание бонусов и штрафов",
      juCommentDef: "Информация не заполнена",
      juError:
          "Судья не назначен на стол на сайте, исправьте это и попробуйте снова!",
      j: "СУ",
      g_a: "Доп",
      g_p: "Штр.",
      g_dp: "Дисц.Ш.",
      restoreGameMsg: "Продолжить незавершённую игру?",
      toggle_timer: "Переключить таймер",
      reset_timer: "Сбросить таймер",
      technical_break: "Техническая пауза",
      technical_break_title: "Техническая пауза",
      technical_break_message: "В игре техническая пауза. Закройте это окно чтобы продолжить.",
      stream_connection_error: "Ошибка сети: Проверьте подключение к интернету. Трансляция может не обновляться.",
      // Login page
      welcome_subtitle: "Добро пожаловать в управление играми Mafia World Tour",
      email_label: "Email",
      email_placeholder: "you@example.com",
      password_placeholder: "••••••••",
      choose_language: "Выберите язык",
      lang_english: "English",
      lang_russian: "Русский",
      lang_ukrainian: "Українська",
      lang_georgian: "ქართული",
      lang_hebrew: "עברית",
      login_meta: "Используйте учетные данные Mafia World Tour для доступа.",
      login_failed: "Ошибка входа",
      network_error: "Ошибка сети",
      // Last Words
      last_words: "Прощальная речь",
      voted_out: "был выгнан городом",
      eliminated_night: "был убит ночью",
      final_speech: "имеет возможность произнести последнюю речь перед выбыванием из игры.",
      player_of: "Игрок {0} из {1}",
      instructions: "Инструкции:",
      allow_speech: "Позвольте убитому игроку произнести последнюю речь",
      share_thoughts: "Игрок может поделиться своими мыслями, подозрениями или стратегией",
      click_continue: "Нажмите \"{0}\", когда речь будет завершена",
      multiple_eliminated: "Несколько игроков были исключены - каждый получает свою очередь",
      goodbye: "Прощаемся",
      undo_vote: "Отмена",
      back_to_night: "Назад в ночь",
      continue_game: "Продолжить игру",
      next_player: "Следующий игрок",
      // Role Assignment
      citizens: "Мирные",
      citizen: "Мирный",
      mafia: "Мафия",
      instructions_roles: "Нажмите на иконки ролей, чтобы изменить роли игроков",
      required_roles: "Требуется: 6 мирных жителей, 2 мафии, 1 дон, 1 шериф",
      hide_roles_instruction: "Используйте кнопку \"Скрыть роли\", чтобы скрыть распределение ролей от игроков",
      click_ready: "Нажмите \"Готов\", когда все роли правильно распределены",
      invalid_distribution: "Неверное распределение ролей!",
      current_distribution: "Текущее: {0} мирных жителей, {1} мафии, {2} дон, {3} шериф",
      // Tournament Seats
      loading_seats: "Загрузка рассадки турнира...",
      tournament_seating: "Рассадка турнира",
      select_session: "Выберите сессию для проведения игры",
      no_seats_available: "Рассадка недоступна",
      failed_load_seats: "Не удалось загрузить рассадку турнира",
      seats_not_generated: "Рассадка еще не сгенерирована или турнир уже закрыт.",
      // Game Results
      game_in_progress: "Игра в процессе",
      search_judge: "Поиск судьи...",
      game_description: "Описание игры...",
      search_penalties: "Поиск штрафов...",
      judge_label: "Судья",
      description_label: "Описание",
      penalty_value: "Штраф: {0}",
      game_statistics: "Статистика игры",
      game_timing: "Тайминг игры",
      start_time: "Начало",
      end_time: "Окончание",
      nights_count: "Ночи",
      // Main Menu
      mafia_app: "Mafia App",
      refresh: "Обновить",
      select_club: "Выбрать клуб",
      tournament_region_flag: "Флаг региона турнира",
      main_menu_subtitle: "Выберите клуб или турнир, чтобы управлять следующей игрой.",
      club_section_description: "Переходите к мероприятиям клуба и запускайте новую игру.",
      club_card_meta: "Управление мероприятиями и играми",
      open_club: "Открыть мероприятия",
      no_clubs_synced: "Клубы еще не синхронизированы. Обновите страницу или проверьте права доступа.",
      tournaments_heading: "Турниры",
      tournament_section_description: "Просматривайте официальные события и открывайте рассадку для своего стола.",
      tournament_card_meta: "Нажмите, чтобы увидеть рассадку и участников",
      view_seats: "Открыть рассадку",
      no_tournaments: "Сейчас нет доступных турниров. Обновите позже, чтобы синхронизировать события.",
      profile_title: "Профиль",
      profile_aria_label: "Профиль",
      club_logo_alt: "Логотип {0}",
      // Game Actions
      select_disqualify: "Выберите игрока для дисквалификации:",
      select_ppk: "Выберите игрока, из-за которого победила противоположная команда:",
      action_label: "Действие:",
      note_label: "Примечание:",
      ppk_note:
        "ППК (победа противоположной команды) используется, когда действия игрока напрямую приводят его команду к поражению. Победителем объявляется противоположная команда.",
      // Player Setup
      add_guest: "Добавить гостя",
      judge_avatar_alt: "Аватар судьи",
      player_avatar_alt: "Аватар {0}",
      guest_player_label: "Гость {0}",
      level_short: "кат. {0}",
      // Day Phase
      first_day: "Первый день",
      day_number: "День {0}",
      first_speaker: "Первый говорящий:",
      nomination_order: "Порядок выставлений: {0}",
      nomination_title: "Игрок {0} выставляет на голосование",
      nomination_prompt: "Выберите игрока для выставления на голосование",
      player_eliminated_tooltip: "Игрок {0} выбыл",
      player_already_nominated: "Игрок {0} уже выставлен",
      nominate_player: "Выставить игрока {0}",
      current_nomination: "Текущее выставление: игрок {0}",
      clear_nomination: "Снять выставление",
      unknown: "Неизвестно",
      vs: "VS",
      day_instructions_title: "Инструкции дневной фазы",
      day_instruction_discuss: "Игроки обсуждают и выставляют подозреваемых",
      day_instruction_vs: "Используйте кнопку VS, чтобы выставить игрока на голосование",
      day_instruction_disabled: "Выбывшие и уже выставленные игроки недоступны",
      day_instruction_fouls: "Нажимайте значки фолов для выдачи наказаний",
      day_instruction_voting: "Начните голосование, когда выставления готовы",
      day_instruction_skip: "Используйте «в ночь», чтобы перейти прямо к ночной фазе",
      current_nominations_title: "Текущие выставления",
      nomination_item: "{0} выставляет {1}",
      // Club Events
      enter_event_title: "Пожалуйста, введите название мероприятия",
      failed_create_event: "Не удалось создать мероприятие",
      confirm_remove_participant: "Вы уверены, что хотите удалить этого участника?",
      loading_participants: "Загрузка участников...",
      actions: "Действия",
      confirm_delete_game: "Вы уверены, что хотите удалить эту игру?",
      confirm_close_event: "Вы уверены, что хотите закрыть это мероприятие?",
      confirm_open_event: "Вы уверены, что хотите переоткрыть это мероприятие?",
      confirm_delete_event: "Вы уверены, что хотите удалить это мероприятие?",
      event_ranking: "Рейтинг мероприятия",
      failed_update_event_ranking: "Не удалось обновить рейтинг мероприятия",
      event_title_label: "Название",
      event_date_label: "Дата",
      event_time_label: "Время",
      event_description_label: "Описание (необязательно)",
      event_description_placeholder: "Описание мероприятия...",
      event_exists_warning: "На эту дату уже существует мероприятие. Хотите создать ещё одно?",
      creating: "Создание...",
      club_prefix: "Клуб: {0}",
      more_events: "... (еще {0})",
      yes: "Да",
      no: "Нет",
      // Night Actions
      select_shooting_target: "Выберите цель для ночной стрельбы:",
      miss: "Промах",
      don_dead_skip: "Дон мёртв - проверка пропускается",
      select_don_check: "Выберите игрока для проверки Дона:",
      next: "Дальше →",
      sheriff_dead_skip: "Шериф мёртв - проверка пропускается",
      select_sheriff_check: "Выберите игрока для проверки Шерифа:",
      check_player: "Проверить игрока {0}",
      player_dead: "Игрок {0} мёртв",
      step_shooting: "Стрельба",
      step_don: "Дон",
      step_sheriff: "Шериф",
      stage_1_shooting: "Этап 1: Ночная стрельба",
      stage_2_don: "Этап 2: Проверка Дона",
      stage_3_sheriff: "Этап 3: Проверка Шерифа",
      // Morning Transition
      no_night_eliminations: "Никто не был убит этой ночью.",
      continue_to_day: "Перейти к дню",
      continue_to_day_number: "Перейти к дню {0}",
      first_victim_note: "Первый убиенный — может назвать мафию",
      select_mafia_prompt: "Выберите до 3 игроков, которых считаете мафией:",
      last_words_note: "Прощальная речь перед выбыванием из игры",
      best_move_unavailable: "Лучший ход недоступен:",
      first_day_eliminations: "В первый день было исключено {0} игроков",
      // Voting
      no_nominations_title: "Нет выставлений",
      no_nominations_desc: "Ни один игрок не был выставлен на голосование.",
      single_nomination: "Выставлен только один игрок: {0}",
      player_will_be_eliminated: "{0} будет исключён.",
      tie_repeat_info:
        "После повторного голосования количество игроков с равным числом голосов не изменилось.",
      tie_exceeds_limit_warning: "Казнь всех {0} игроков превышает лимит!",
      tie_execute_tooltip: "Казнить всех {0} игроков",
      tie_execute_limit_tooltip: "Нельзя казнить {0} игроков (лимит: {1})",
      shootout_round: "Перестрелка {0}",
      candidate_progress: "Кандидат {0} из {1} | Осталось голосов: {2}",
      candidate_receives_remaining:
        "Игрок #{0} получает все оставшиеся голоса: {1}",
      finish_voting: "Завершить голосование",
      all_remaining_votes: "Все оставшиеся голоса",
      tied_players: "Игроки с равным количеством голосов:",
      rule_50_percent: "Правило 50%:",
      cannot_execute_more: "Нельзя казнить больше {0} игроков (50% от {1} живых игроков).",
      three_way_tie_rule: "Правило 3 при 9",
      cannot_execute_three_way_tie: "По правилам ФИИМ нельзя казнить всех 3 игроков, когда в игре 9 игроков и голоса поделились между 3 кандидатами.",
      select_action: "Выберите действие:",
      current_results: "Текущие результаты:",
      // Penalty section
      penalty_section: "п.{0}",
      foul_four_heading: "Наказание за 4-й фол:",
      foul_four_instructions:
        "Необходимо решить, что сделать с игроком.",
      foul_three_heading: "Наказание за 3-й фол:",
      foul_three_instructions:
        "Выберите, в какой день игрок пропустит речь.",
      // Stream settings
      stream_settings: "Настройки трансляции",
      stream_theme_label: "Оформление плашек",
      stream_language_label: "Язык трансляции",
      theme_classic: "Классические",
      theme_dark: "Тёмные",
      theme_noroles: "Без ролей",
      theme_cartel: "Cartel",
      theme_xcity: "X-City",
      settings_button: "Настройки",
      app_language_label: "Язык приложения",
    },
  },
  // Ukrainian dictionary (index 2)
  {
    ph: {
      registration: "Швидка реєстрація",
      total: "ВСЬОГО",
      create: "Створити",
      event_o: "Активні заходи",
      event_p: "Минулі заходи",
      event_c: "Створити новий захід",
      event_t: "Введіть назву (Ігровий вечір/Міні кап)",
      prtcp: "УЧАСНИКИ",
      gamescaps: "ІГРИ",
      gamecaps: "ІГРА",
      event_pa: "СТОРІНКА ЗАХОДУ",
      killed: "ПУ",
      in: "На місці",
      reopen: "Перевідкрити",
      games: "Ігри",
      cgname: "гра",
      copylink: "Скопіювати",
      startclub: "ПОЧАТИ НОВУ ГРУ",
      pwarning:
                  "Ви не є суддею даного турніру - всі зміни не будуть відправлені на сервер!",
      swarning:
                  "Ви впевнені, що хочете відправити зміни на сервер? Екран введених даних закриється. Будь ласка, майте на увазі, що після успішного відправлення результатів ви автоматично будете перенаправлені на головний екран!",
      rwarning:
                  "Ви намагаєтеся оновити гру - це тільки оновлення допов, штрафів і коментарів. Якщо вам необхідно оновити щось інше, будь ласка, переведіть всю гру повністю!",
      stage: "Етап",
      start: "Почати",
      delete: "Видалити",
      table: "Стіл",
      session: "Тур",
      back: "← Назад",
      noseats:
          "Розсадження ще не створено або турнір вже закрито.",
      none: "немає",
      voting: "Голосування",
      cselerror:
          "Ви повинні вибрати клуб, щоб проводити гру. Ви впевнені, що ваш клуб підтримується системою? Спробуйте синхронізувати дані.",
      dph: "Денна фаза",
      nph: "Нічна фаза",
      resph: "Результати",
      sclub: "Ваші клуби",
      players: "Гравці",
      citydec: "Рішення міста",
      execall: "Стратити всіх",
      vanga: "вгадує мафію",
      lms: "говорить заповіт",
      skip: "Пропустити",
      confirm: "Підтвердити",
      plgot4f: "Гравець отримав 4 фоли",
      rcnt: " Скидання фолів",
      plgot3f: "Гравець отримав 3-й фол і не буде говорити",
      tday: "цей день",
      nday: "наступний день",
      novoting: "Був виставлений один гравець, в місті ніч",
      bye1player: "Один гравець був виставлений, гравець",
      bye1player2: "покидає гру",
      exec: "Стратити",
      mmenu: "Головне меню",
      logout: "Вихід",
      close: "Закрити",
      morning: "Ранок",
      btday: "Назад в день",
      cancelgame: "Скасувати гру",
      ppk: "ППК",
      disqualify: "Дискваліфікувати",
      ppkred: "Мирні перемогли завдяки гравцеві номер:",
      ppkblack: "Мафія перемогла завдяки гравцеві номер:",
      chooseact: "Дії",
      loadall: "Завантажити всі турніри",
      roles: "Ролі",
      hroles: "Приховати ролі",
      gngt: "В ніч",
      confirm_cancel_game: "Підтвердити скасування гри?" ,
      confirm_cancel_game_message: "Ви впевнені, що хочете скасувати гру? Весь прогрес буде втрачено.",
      confirm_go_night: "Підтвердити перехід в ніч?",
      confirm_go_night_message: "Ви впевнені, що хочете перейти в ніч без голосування?",
      confirm_back_to_day: "Підтвердити повернення до дня?",
      confirm_back_to_day_message: "Ви впевнені, що хочете повернутися до денної фази? Прогрес нічної фази буде втрачено.",
      yes_cancel: "Так, скасувати",
      yes_proceed: "Так, перейти",
      yes_return: "Так, повернутися",
      disqualification_warning_title: "Скасування голосування",
      disqualification_warning_message: "За правилами ФІІМ голосування в цей день скасовується через дискваліфікацію гравця в поточній або попередній фазі.",
      skip_voting_go_night: "У ніч",
      vote_anyway: "Голосувати все одно",
      fls: "Фоли",
      sroles: "Показати ролі",
      upnow: "Завантажити зараз",
      save: "Зберегти",
      don: "Дон",
      maf: "Мафія",
      shrf: "Шериф",
      fblood: "Перша жертва",
      lh: "Кращий хід",
      na: "Не застосовується",
      lorder: "Порядок виходу",
      otstr: "Відстріл",
      donchk: "Перевірки дона",
      shchk: "Перевірки шерифа",
      logedas: "Ви увійшли як ",
      ctwon: "Мирні перемогли",
      mafwon: "Мафія перемогла ",
      draw: "Нічия",
      upfail: "Завантаження не вдалося, дані збережені, спробуйте ще раз",
      plsactivate:
          "Будь ласка, активуйте свій обліковий запис через email і увійдіть в систему",
      player: "Гравець",
      isdup: "дублюється",
      pwd: "Пароль",
      cncl: "Скасування",
      nxt: "Далі",
      srch: "Пошук",
      nrate: "Нерейтингове",
      yrate: "Рейтингове",
      rdy: "Готово",
      pwlength: "Пароль повинен містити 3–100 символів",
      header: " Mafia App",
      submit: "Увійти",
      login: "Вхід",
      loading: "Завантаження",
      adding_players: "Розсадження гравців",
      intro_n: "Роздача та домовка",
      juComment: "Опис бонусів і штрафів",
      juCommentDef: "Інформація не заповнена",
      juError:
          "Суддя не призначений на стіл на сайті, виправте це і спробуйте знову!",
      j: "СУ",
      g_a: "Дод.",
      g_p: "Штр.",
      g_dp: "Дисц.Ш.",
      restoreGameMsg: "Продовжити незавершену гру?",
      toggle_timer: "Перемкнути таймер",
      reset_timer: "Скинути таймер",
      technical_break: "Технічна пауза",
      technical_break_title: "Технічна пауза",
      technical_break_message: "У грі технічна пауза. Закрийте це вікно щоб продовжити.",
      stream_connection_error: "Помилка мережі: Перевірте підключення до інтернету. Трансляція може не оновлюватися.",
      // Login page
      welcome_subtitle: "Ласкаво просимо до управління іграми Mafia World Tour",
      email_label: "Email",
      email_placeholder: "you@example.com",
      password_placeholder: "••••••••",
      choose_language: "Виберіть мову",
      lang_english: "English",
      lang_russian: "Русский",
      lang_ukrainian: "Українська",
      lang_georgian: "ქართული",
      lang_hebrew: "עברית",
      login_meta: "Використовуйте облікові дані Mafia World Tour для доступу.",
      login_failed: "Помилка входу",
      network_error: "Помилка мережі",
      // Last Words
      last_words: "Прощальна промова",
      voted_out: "Більшістю голосів покидає місто",
      eliminated_night: "був убитий вночі",
      final_speech: "має останню хвилину в цій грі.",
      player_of: "Гравець {0} з {1}",
      instructions: "Інструкції:",
      allow_speech: " Дозвольте вбитому гравцеві виголосити останню промову",
      share_thoughts: "Гравець може поділитися своїми думками, підозрами або стратегією",
      click_continue: "Натисніть \"{0}\", коли промова буде завершена",
      multiple_eliminated: "Кілька гравців були виключені - кожен отримує свою чергу",
      goodbye: "Прощаємося",
      undo_vote: "Скасування",
      back_to_night: "Назад у ніч",
      continue_game: "Продовжити гру",
      next_player: "Наступний гравець",
      // Role Assignment
      citizens: "Мирні",
      citizen: "Мирний",
      mafia: "Мафія",
      instructions_roles: "Натисніть на іконки ролей, щоб змінити ролі гравців",
      required_roles: "Потрібно: 6 мирних жителів, 2 мафії, 1 дон, 1 шериф",
      hide_roles_instruction: "Використовуйте кнопку \"Приховати ролі\", щоб приховати розподіл ролей від гравців",
      click_ready: "Натисніть \"Готово\", коли всі ролі правильно розподілені",
      invalid_distribution: "Неправильний розподіл ролей!",
      current_distribution: "Поточний: {0} мирних жителів, {1} мафії, {2} дон, {3} шериф",
      // Tournament Seats
      loading_seats: "Завантаження розсадки турніру...",
      tournament_seating: "Розсадка турніру",
      select_session: "Виберіть сесію для проведення гри",
      no_seats_available: "Розсадження недоступне",
      failed_load_seats: "Не вдалося завантажити розсадження турніру",
      seats_not_generated: "Розсадження ще не згенеровано або турнір вже закрито.",
      // Результати гри
      game_in_progress: "Гра в процесі",
      search_judge: "Пошук судді...",
      game_description: "Опис гри...",
      search_penalties: "Пошук штрафів...",
      judge_label: "Суддя",
      description_label: "Опис",
      penalty_value: "Штраф: {0}",
      game_statistics: "Статистика гри",
      game_timing: "Таймінг гри",
      start_time: "Початок",
      end_time: "Закінчення",
      nights_count: "Ночі",
      // Main Menu
      mafia_app: "Mafia App",
      refresh: "Оновити",
      select_club: "Вибрати клуб",
      tournament_region_flag: "Прапор регіону турніру",
      main_menu_subtitle: "Виберіть клуб або турнір, щоб керувати наступною грою.",
      club_section_description: "Переходьте до заходів клубу і запускайте нову гру.",
      club_card_meta: "Управління заходами та іграми",
      open_club: "Відкрити заходи",
      no_clubs_synced: "Клуби ще не синхронізовані. Оновіть сторінку або перевірте права доступу.",
      tournaments_heading: "Турніри",
      tournament_section_description: "Переглядайте офіційні події та відкривайте розсадження для свого столу.",
      tournament_card_meta: "Натисніть, щоб побачити розсадження та учасників",
      view_seats: "Відкрити розсадження",
      no_tournaments: "Зараз немає доступних турнірів. Оновіть пізніше, щоб синхронізувати події.",
      profile_title: "Профіль",
      profile_aria_label: "Профіль",
      club_logo_alt: "Логотип {0}",
      // Game Actions
      select_disqualify: "Виберіть гравця для дискваліфікації:",
      select_ppk: "Виберіть гравця, через якого перемогла протилежна команда:",
      action_label: "Дія:",
      note_label: "Примітка:",
      ppk_note:
        "ППК (перемога протилежної команди) використовується, коли дії гравця безпосередньо призводять його команду до поразки. Переможцем оголошується протилежна команда.",
      // Player Setup
      add_guest: "Додати гостя",
      judge_avatar_alt: "Аватар судді",
      player_avatar_alt: "Аватар {0}",
      guest_player_label: "Гість {0}",
      level_short: "кат. {0}",
      // Day Phase
      first_day: "Перший день",
      day_number: "День {0}",
      first_speaker: "Перший доповідач:",
      nomination_order: "Порядок виставлень: {0}",
      nomination_title: "Гравець {0} виставляє на голосування",
      nomination_prompt: "Виберіть гравця для виставлення на голосування",
      player_eliminated_tooltip: "Гравець {0} вибув",
      player_already_nominated: "Гравець {0} вже виставлений",
      nominate_player: "Виставити гравця {0}",
      current_nomination: "Поточне виставлення: гравець {0}",
      clear_nomination: "Зняти виставлення",
      unknown: "Невідомо",
      vs: "VS",
      day_instructions_title: "Інструкції денної фази",
      day_instruction_discuss: "Гравці обговорюють і виставляють підозрюваних",
      day_instruction_vs: "Використовуйте кнопку VS, щоб виставити гравця на голосування",
      day_instruction_disabled: "Вибулі та вже виставлені гравці недоступні",
      day_instruction_fouls: "Натискайте значки фолів для видачі покарань",
      day_instruction_voting: "Почніть голосування, коли виставлення готові",
      day_instruction_skip: "Використовуйте «в ніч», щоб перейти прямо до нічної фази",
      current_nominations_title: "Поточні виставлення",
      nomination_item: "{0} виставляє {1}",
      // Club Events
      enter_event_title: "Будь ласка, введіть назву заходу",
      failed_create_event: "Не вдалося створити захід",
      confirm_remove_participant: "Ви впевнені, що хочете видалити цього учасника?",
      loading_participants: "Завантаження учасників...",
      actions: "Дії",
      confirm_delete_game: "Ви впевнені, що хочете видалити цю гру?",
      confirm_close_event: "Ви впевнені, що хочете закрити цей захід?",
      confirm_open_event: "Ви впевнені, що хочете знову відкрити цей захід?",
      confirm_delete_event: "Ви впевнені, що хочете видалити цей захід?",
      event_ranking: "Рейтинг заходу",
      failed_update_event_ranking: "Не вдалося оновити рейтинг заходу",
      event_title_label: "Назва",
      event_date_label: "Дата",
      event_time_label: "Час",
      event_description_label: "Опис (не обов'язково)",
      event_description_placeholder: "Опис заходу...",
      event_exists_warning: "На цю дату вже існує захід. Хочете створити ще один?",
      creating: "Створення...",
      club_prefix: "Клуб: {0}",
      more_events: "... (ще {0})",
      yes: "Так",
      no: "Ні",
      // Нічні дії
      select_shooting_target: "Виберіть ціль для нічного пострілу:",
      miss: "Промах",
      don_dead_skip: "Дон мертвий - звірка пропускається",
      select_don_check: "Виберіть гравця для перевірки Дона:",
      next: "Далі →",
      sheriff_dead_skip: "Шериф мертвий - звірка пропускається",
      select_sheriff_check: "Виберіть гравця для перевірки Шерифа:",
      check_player: "Перевірити гравця {0}",
      player_dead: "Гравець {0} мертвий",
      step_shooting: "Постріл",
      step_don: "Дон",
      step_sheriff: "Шериф",
      stage_1_shooting: "Етап 1: Нічний постріл",
      stage_2_don: "Етап 2: Звірка Дона",
      stage_3_sheriff: "Етап 3: Звірка Шерифа",
      // Morning Transition
      no_night_eliminations: "Ніхто не був убитий цієї ночі.",
      continue_to_day: "Перейти до дня",
      continue_to_day_number: "Перейти до дня {0}",
      first_victim_note: "Перший вбитий — може назвати мафію",
      select_mafia_prompt: "Виберіть до 3 гравців, яких вважаєте мафією:",
      last_words_note: "Прощальна промова в цій грі",
      best_move_unavailable: "Найкращий хід недоступний:",
      first_day_eliminations: "У перший день було виключено {0} гравців",
      // Voting
      no_nominations_title: "Немає виставлень",
      no_nominations_desc: "Жоден гравець не був виставлений на голосування.",
      single_nomination: "Виставлений тільки один гравець: {0}",
      player_will_be_eliminated: "{0} буде виключений.",
      tie_repeat_info:
        "Після повторного голосування кількість гравців з рівною кількістю голосів не змінилася.",
      tie_exceeds_limit_warning: "Страта всіх {0} гравців перевищує ліміт!",
      tie_execute_tooltip: "Стратити всіх {0} гравців",
      tie_execute_limit_tooltip: "Не можна стратити {0} гравців (ліміт: {1})",
      shootout_round: "Перестрілка {0}",
      candidate_progress: "Кандидат {0} з {1} | Залишилося голосів: {2}",
      candidate_receives_remaining:
        "Гравець #{0} отримує всі голоси, що залишилися: {1}",
      finish_voting: "Завершити голосування",
      all_remaining_votes: "Всі голоси, що залишилися",
      tied_players: "Гравці з рівною кількістю голосів:",
      rule_50_percent: "Правило 50%:",
      cannot_execute_more: "Не можна стратити більше {0} гравців (50% від {1} живих гравців).",
      three_way_tie_rule: "Правило 3 при 9",
      cannot_execute_three_way_tie: "За правилами ФІІМ не можна стратити всіх 3 гравців, коли в грі 9 гравців і голоси поділилися між 3 кандидатами.",
      select_action: "Виберіть дію:",
      current_results: "Поточні результати:",
      // Penalty section
      penalty_section: "п.{0}",
      foul_four_heading: "Покарання за 4-й фол:",
      foul_four_instructions:
        "Необхідно вирішити, що зробити з гравцем.",
      foul_three_heading: "Покарання за 3-й фол:",
      foul_three_instructions:
        "Виберіть, в який день гравець пропустить промову.",
      // Stream settings
      stream_settings: "Налаштування трансляції",
      stream_theme_label: "Оформлення плашок",
      stream_language_label: "Мова трансляції",
      theme_classic: "Класичні",
      theme_dark: "Темні",
      theme_noroles: "Без ролей",
      theme_cartel: "Cartel",
      theme_xcity: "X-City",
      settings_button: "Налаштування",
      app_language_label: "Мова додатка",
    },
  },
  // Georgian dictionary (index 3)
  {
    ph: {
      registration: "სწრაფი რეგისტრაცია",
      total: "სულ",
      create: "შექმნა",
      event_o: "აქტიური ღონისძიებები",
      event_p: "გასული ღონისძიებები",
      event_c: "ახალი ღონისძიების შექმნა",
      event_t: "სახელი (თამაშის საღამო/მინი-კაპი)",
      prtcp: "მონაწილეები",
      gamescaps: "თამაშები",
      gamecaps: "თამაში",
      event_pa: "ღონისძიების გვერდი",
      killed: "მოკლულია",
      in: "ადგილზე",
      reopen: "ხელახლა გახსნა",
      games: "თამაშები",
      cgname: "კლუბის სახელი",
      copylink: "კოპირება",
      startclub: "ახალი თამაშის დაწყება",
      pwarning:
        "თქვენ არ ხართ მსაჯი ამ ტურნირში - ყველა ცვლილება არ გაიგზავნება სერვერზე!",
      swarning:
        "დარწმუნებული ხართ, რომ გსურთ შედეგების სერვერზე გაგზავნა? ეკრანი დაიხურება. გთხოვთ გაითვალისწინოთ, რომ წარმატებული გაგზავნის შემდეგ თქვენ დაბრუნდებით მთავარ ეკრანზე!",
      rwarning:
        "თქვენ ცდილობთ თამაშის შედეგების განახლებას - ეს მხოლოდ ბონუსებს, სასჯელებს და კომენტარს განაახლებს. თუ სხვა განახლებები გჭირდებათ, გთხოვთ ხელახლა შეიყვანოთ მთელი თამაში!",
      stage: "ეტაპი",
      start: "დაწყება",
      delete: "წაშლა",
      table: "მაგიდა",
      session: "ტური",
      back: "← დაბრუნება",
      noseats:
        "გასაჯდომი სია არ არის შექმნილი ან ტურნირი დახურულია.",
      none: "არაა",
      voting: "კენჭისყრა",
      cselerror:
        "თქვენ უნდა აირჩიოთ კლუბი თამაშის მოდერირებისთვის. დარწმუნებული ხართ, რომ თქვენი კლუბი მხარდაჭერილია და ჩამოთვლილია? სცადეთ მონაცემების ხელახლა სინქრონიზაცია.",
      dph: "დღის ფაზა",
      nph: "ღამის ფაზა",
      resph: "შედეგები",
      sclub: "კლუბის არჩევა",
      players: "მოთამაშეები",
      citydec: "ქალაქის გადაწყვეტილება",
      execall: "მოთამაშეების აყენება",
      vanga: "საუკეთესო სვლა",
      lms: "იტყვის ანდერძს",
      skip: "გამოტოვება",
      confirm: "დადასტურება",
      plgot4f: "მოთამაშეს მიენიჭა 4 ფოლი",
      rcnt: "ფოლების განულება",
      plgot3f: "მოთამაშეს მიენიჭა 3 ფოლი",
      tday: "ეს დღე",
      nday: "შემდეგი დღე",
      novoting: "ამ დღეს კენჭისყრა არ ტარდება",
      bye1player: "ქალაქში მხოლოდ ერთი კანდიდატურაა დაყენებული, ნომერი",
      bye1player2: "ტოვებს თამაშს",
      exec: "სიკვდილით დასჯა",
      mmenu: "მთავარი მენიუ",
      logout: "გასვლა",
      close: "დაკეტვა",
      morning: "დილა",
      btday: "დღეში დაბრუნება",
      cancelgame: "თამაშის გაუქმება",
      ppk: "პპკ",
      disqualify: "დისკვალიფიკაცია",
      ppkred: "მოქალაქე გაიმარჯვეს მოთამაშის ნომრის გამო:",
      ppkblack: "მაფიამ გაიმარჯვა მოთამაშის ნომრის გამო:",
      chooseact: "მოქმედებები",
      loadall: "ყველა ტურნირების ჩატვირთვა",
      roles: "როლები",
      hroles: "როლების დამალვა",
      gngt: "ღამე",
      confirm_cancel_game: "დადასტურება: თამაშის გაუქმება?",
      confirm_cancel_game_message: "დარწმუნებული ხართ, რომ გსურთ თამაშის გაუქმება? მთელი პროგრესი დაიკარგება.",
      confirm_go_night: "დადასტურება: გადასვლა ღამეში?",
      confirm_go_night_message: "დარწმუნებული ხართ, რომ გადახვალთ ღამეში კენჭისყრის გარეშე?",
      confirm_back_to_day: "დადასტურება: დაბრუნება დღეში?",
      confirm_back_to_day_message: "დარწმუნებული ხართ, რომ დაბრუნდებით დღეში? ღამის ფაზის პროგრესი დაიკარგება.",
      yes_cancel: "დიახ, გაუქმება",
      yes_proceed: "დიახ, გაგრძელება",
      yes_return: "დიახ, დაბრუნება",
      disqualification_warning_title: "კენჭისყრის გაუქმება",
      disqualification_warning_message: "FIIM-ის წესებით ამ დღეს კენჭისყრა უქმდება მიმდინარე ან წინა ფაზაში დისკვალიფიკაციის გამო.",
      skip_voting_go_night: "ღამე",
      vote_anyway: "კენჭისყრა მაინც",
      fls: "ფოლები",
      sroles: "როლების ჩვენება",
      upnow: "ატვირთვა ახლავე",
      save: "შენახვა",
      don: "დონი",
      maf: "მაფია",
      shrf: "შერიფი",
      fblood: "პირველი მსხვერპლი",
      lh: "საუკეთესო სვლა",
      na: "არ ვრცელდება",
      lorder: "გასვლის რიგი",
      otstr: "გასროლა",
      donchk: "დონის შემოწმებები",
      shchk: "შერიფის შემოწმებები",
      logedas: "შედით როგორც ",
      ctwon: "მშვიდობიანებმა მოიგეს",
      mafwon: "მაფიამ მოიგო",
      draw: "ფრე",
      upfail:
        "ატვირთვა ვერ მოხერხდა, მონაცემები შენახულია, სცადეთ კვლავ",
      plsactivate:
        "გთხოვთ, გაააქტიუროთ ანგარიში ელფოსტის საშუალებით და შედით სისტემაში",
      player: "მოთამაშე",
      isdup: "დუბლირდება",
      pwd: "პაროლი",
      cncl: "გაუქმება",
      nxt: "შემდეგი",
      srch: "ძებნა",
      nrate: "არარეიტინგული",
      yrate: "რეიტინგული",
      rdy: "მზადაა",
      pwlength: "პაროლი უნდა იყოს 3–100 სიმბოლო",
      header: " Mafia App",
      submit: "შესვლა",
      login: "ავტორიზაცია",
      loading: "იტვირთება",
      adding_players: "მოთამაშეების დამატება",
      intro_n: "როლების განაწილება და შეთანხმება",
      juComment: "ბონუსებისა და ჯარიმების აღწერა",
      juCommentDef: "ინფორმაცია არ არის შევსებული",
      juError:
        "მსაჯი არ იყო მინიჭებული მაგიდაზე ვებსაიტზე, გთხოვთ გამოასწოროთ და ხელახლა სცადოთ თამაშის ჩატვირთვა!",
      j: "მსაჯი",
      g_a: "დამატ.",
      g_p: "ჯარ.",
      g_dp: "დისც. ჯ.",
      restoreGameMsg: "გინდათ წინა თამაშის აღდგენა?",
      toggle_timer: "ტაიმერის გადართვა",
      reset_timer: "ტაიმერის განულება",
      technical_break: "ტექნიკური პაუზა",
      technical_break_title: "ტექნიკური პაუზა",
      technical_break_message: "თამაშში ტექნიკური პაუზაა. გასაგრძელებლად დახურეთ ეს ფანჯარა.",
      stream_connection_error: "ქსელის შეცდომა: შეამოწმეთ ინტერნეტი. ტრანსლაცია შეიძლება არ განახლდეს.",
      vs: "VS",
      // Login page
      welcome_subtitle: "მოგესალმებით Mafia World Tour-ის თამაშების მართვაში",
      email_label: "Email",
      email_placeholder: "you@example.com",
      password_placeholder: "••••••••",
      choose_language: "აირჩიეთ ენა",
      lang_english: "English",
      lang_russian: "Русский",
      lang_ukrainian: "Українська",
      lang_georgian: "ქართული",
      lang_hebrew: "עברית",
      login_meta: "შესასვლელად გამოიყენეთ Mafia World Tour-ის ანგარიშის მონაცემები.",
      login_failed: "შესვლის შეცდომა",
      network_error: "ქსელური შეცდომა",
      // Last Words
      last_words: "ბოლო სიტყვა",
      voted_out: "ქალაქმა გამოაგდო",
      eliminated_night: "ღამით მოკლეს",
      final_speech: "გაქვს ბოლო სიტყვის თქმის შესაძლებლობა თამაშის დატოვებამდე.",
      player_of: "მოთამაშე {0} / {1}",
      instructions: "ინსტრუქციები:",
      allow_speech: "ნება დართეთ მოკლულ მოთამაშეს თქვას ბოლო სიტყვა",
      share_thoughts: "მოთამაშეს შეუძლია გაუზიაროს აზრები, ეჭვები ან სტრატეგია",
      click_continue: "დააჭირეთ \"{0}\", როდესაც სიტყვა დასრულდება",
      multiple_eliminated: "რამდენიმე მოთამაშე გამოირიცხა — თითოეულს თავისი რიგი",
      goodbye: "მშვიდობით",
      undo_vote: "გაუქმება",
      back_to_night: "ღამეში დაბრუნება",
      continue_game: "თამაშის გაგრძელება",
      next_player: "შემდეგი მოთამაშე",
      // Role Assignment
      citizens: "მოქალაქე",
      citizen: "მოქალაქე",
      mafia: "მაფია",
      instructions_roles: "დააჭირეთ როლების ხატულებს მოთამაშეთა როლების შესაცვლელად",
      required_roles: "საჭიროა: 6 მოქალაქე, 2 მაფია, 1 დონი, 1 შერიფი",
      hide_roles_instruction: "გამოიყენეთ \"როლების დამალვა\" ღილაკი როლების განაწილების დასამალად",
      click_ready: "დააჭირეთ \"მზადაა\", როდესაც ყველა როლი სწორად არის განაწილებული",
      invalid_distribution: "არასწორი განაწილება!",
      current_distribution: "მიმდინარე: {0} მოქალაქე, {1} მაფია, {2} დონი, {3} შერიფი",
      // Tournament Seats
      loading_seats: "ტურნირის გასაჯდომი სიის ჩატვირთვა...",
      tournament_seating: "ტურნირის გასაჯდომი სია",
      select_session: "აარჩიეთ სესია თამაშის ჩასატარებლად",
      no_seats_available: "გაჯდომა მიუწვდომელია",
      failed_load_seats: "გაჯდომის ჩატვირთვა ვერ მოხერხდა",
      seats_not_generated: "გაჯდომა ჯერ არ არისგენერირებული ან ტურნირი უკვე დახურულია.",
      // Game Results
      game_in_progress: "თამაში მიმდინარეობს",
      search_judge: "მოსამართლის ძიება...",
      game_description: "თამაშის აღწერა...",
      search_penalties: "ჯარიმების ძიება...",
      judge_label: "მოსამართლე",
      description_label: "აღწერა",
      penalty_value: "ჯარიმა: {0}",
      game_statistics: "თამაშის სტატისტიკა",
      game_timing: "თამაშის ტაიმინგი",
      start_time: "დაწყება",
      end_time: "დასასრული",
      nights_count: "ღამეები",
      // Main Menu
      mafia_app: "Mafia App",
      refresh: "განახლება",
      select_club: "კლუბის არჩევა",
      tournament_region_flag: "ტურნირის რეგიონის დროშა",
      main_menu_subtitle: "აარჩიეთ კლუბი ან ტურნირი შემდეგი თამაშის სამართავად.",
      club_section_description: "გადადით კლუბის ღონისძიებებზე და გაუშვით ახალი თამაში.",
      club_card_meta: "ღონისძიებებისა და თამაშების მართვა",
      open_club: "ღონისძიებების გახსნა",
      no_clubs_synced: "კლუბები ჯერ არ არის სინქრონიზებული. განაახლეთ გვერდი ან შეამოწმეთ უფლებები.",
      tournaments_heading: "ტურნირები",
      tournament_section_description: "ნახეთ ოფიციალური ღონისძიებები და გახსენით თქვენი მაგიდის გასაჯდომი სია.",
      tournament_card_meta: "დააჭირეთ მოთამაშეების და მათი ადგილების ცხრილის სანახავად",
      view_seats: "ცხრილის გახსნა",
      no_tournaments: "ამჟამად ტურნირები არაა ხელმისაწვდომი. სცადეთ მოგვიანებით.",
      profile_title: "პროფილი",
      profile_aria_label: "პროფილი",
      club_logo_alt: "{0}-ის ლოგო",
      // Game Actions
      select_disqualify: "აირჩიეთ დისკვალიფიკაცია",
      select_ppk: "აირჩიეთ პპკ",
      action_label: "მოქმედება",
      note_label: "შენიშვნა",
      ppk_note:
        "PPK (საპირისპირო გუნდის გამარჯვება) გამოიყენება, როდესაც მოთამაშის ქმედებები პირდაპირ იწვევს მისი გუნდის წაგებას. გამარჯვებულად გამოცხადდება საპირისპირო გუნდი.",
      // Player Setup
      add_guest: "დამატება სტუმრისა",
      judge_avatar_alt: "მოსამართლის ავატარი",
      player_avatar_alt: "ავატარი {0}",
      guest_player_label: "სტუმარი {0}",
      level_short: "დონე {0}",
      // Day Phase
      first_day: "პირველი დღე",
      day_number: "დღე {0}",
      first_speaker: "გამხსნელი",
      nomination_order: "მოსაუბრეთა რიგითობა: {0}",
      nomination_title: "მოთამაშე {0} აყენებს კანდიდატურას",
      nomination_prompt: "კენჭისყრაზე წაყენება",
      player_eliminated_tooltip: "მოთამაშე {0} გამოირიცხა",
      player_already_nominated: "მოთამაშე {0} უკვე წარდგენილია",
      nominate_player: "წარადგინე მოთამაშე {0}",
      current_nomination: "მიმდინარე წარდგენა: მოთამაშე {0}",
      clear_nomination: "წარდგენის მოხსნა",
      unknown: "უცნობი",
      day_instructions_title: "დღის ფაზის ინსტრუქციები",
      day_instruction_discuss: "მოთამაშეები განიხილავენ და აყენებენ ეჭვმიტანილებს",
      day_instruction_vs: "გამოიყენეთ ღილაკი VS კანდიდატის წარსადგენად",
      day_instruction_disabled: "გამორიცხულ და უკვე წარდგენილ მოთამაშეებს ვერ აარჩევთ",
      day_instruction_fouls: "დააჭირეთ ფოლების ხატულებს დასჯისთვის",
      day_instruction_voting: "დაიწყეთ კენჭისყრა, როცა წარდგენები მზად იქნება",
      day_instruction_skip: "გამოიყენეთ „ღამეში“, რათა პირდაპირ ღამის ფაზაზე გადახვიდეთ",
      current_nominations_title: "მიმდინარე წარდგენები",
      nomination_item: "{0} აყენებს {1}-ს",
      // Club Events
      enter_event_title: "შეიყვანეთ ღონისძიების სათაური",
      failed_create_event: "ღონისძიების შექმნა ვერ მოხერხდა",
      confirm_remove_participant: "ამოიღოთ მონაწილე სიიდან?",
      loading_participants: "მონაწილეები იტვირთება...",
      actions: "მოქმედებები",
      confirm_delete_game: "დარწმუნებული ხართ, რომ გსურთ თამაშის წაშლა?",
      confirm_close_event: "დარწმუნებული ხართ, რომ გსურთ ამ ღონისძიების დახურვა?",
      confirm_open_event: "დარწმუნებული ხართ, რომ გსურთ ამ ღონისძიების ხელახალი გახსნა?",
      confirm_delete_event: "დარწმუნებული ხართ, რომ გსურთ ამ ღონისძიების წაშლა?",
      event_ranking: "ღონისძიების რეიტინგი",
      failed_update_event_ranking: "რейтингის განახლება ვერ მოხერხდა",
      event_title_label: "სათაური",
      event_date_label: "თარიღი",
      event_time_label: "დრო",
      event_description_label: "აღწერა (არასავალდებულო)",
      event_description_placeholder: "ღონისძიების აღწერა...",
      event_exists_warning: "ამ თარიღზე ღონისძიება უკვე არსებობს. გსურთ შექმნათ კიდევ ერთი?",
      creating: "იქმნება...",
      club_prefix: "კლუბი: {0}",
      more_events: "... (კიდევ {0})",
      yes: "დიახ",
      no: "არა",
      // Night Actions
      select_shooting_target: "აარჩიეთ ღამის სროლის სამიზნე:",
      miss: "აცილება",
      don_dead_skip: "დონი მკვდარია — შემოწმება გამოტოვებულია",
      select_don_check: "აარჩიეთ მოთამაშე დონის შესამოწმებლად:",
      next: "შემდეგი →",
      sheriff_dead_skip: "შერიფი მკვდარია — შემოწმება გამოტოვებულია",
      select_sheriff_check: "აარჩიეთ მოთამაშე შერიფის შესამოწმებლად:",
      check_player: "შეამოწმე მოთამაშე {0}",
      player_dead: "მოთამაშე {0} მკვდარია",
      step_shooting: "სროლა",
      step_don: "დონი",
      step_sheriff: "შერიფი",
      stage_1_shooting: "ეტაპი 1: ღამის სროლა",
      stage_2_don: "ეტაპი 2: დონის შემოწმება",
      stage_3_sheriff: "ეტაპი 3: შერიფის შემოწმება",
      // Morning Transition
      no_night_eliminations: "ამ ღამეს არავინ მოკვდა.",
      continue_to_day: "გადადი დღეში",
      continue_to_day_number: "გადადი დღეში {0}",
      first_victim_note: "პირველი მოკლულის საუკეთესო სვლა",
      select_mafia_prompt: "აარჩიეთ მაქს. 3 მოთამაშე, ვინც თქვენი აზრით მაფიაა:",
      last_words_note: "ბოლო სიტყვა თამაშის დატოვებამდე",
      best_move_unavailable: "საუკეთესო სვლა მიუწვდომელია:",
      first_day_eliminations: "პირველ დღეს გამოირიცხა {0} მოთამაშე",
      // Voting
      no_nominations_title: "წარდგენები არ არის",
      no_nominations_desc: "ვერცერთი მოთამაშე არ იქნა წარდგენილი.",
      single_nomination: "მხოლოდ ერთი კანდიდატი: {0}",
      player_will_be_eliminated: "{0} ტოვებს თამაშს.",
      tie_repeat_info:
        "განმეორებითი კენჭისყრის შემდეგ თანაბარი ხმების რაოდენობა არ შეიცვალა.",
      tie_exceeds_limit_warning: "ყველა {0} მოთამაშეს სიკვდილით დასჯა ლიმიტს სცდება!",
      tie_execute_tooltip: "სიკვდილით დასაჯე ყველა {0} მოთამაშე",
      tie_execute_limit_tooltip: "შეუძლებელია {0} მოთამაშის დასჯა (ლიმიტი: {1})",
      shootout_round: "გაყოფა {0}",
      candidate_progress: "კანდიდატი {0} / {1} | დარჩენილი ხმები: {2}",
      candidate_receives_remaining:
        "მოთამაშე №{0} იღებს ყველა დარჩენილ ხმას: {1}",
      finish_voting: "კენჭისყრის დასრულება",
      all_remaining_votes: "ყველა დარჩენილი ხმა",
      tied_players: "ერთნაირი ხმების მქონე მოთამაშეები:",
      rule_50_percent: "50%-ის წესი:",
      cannot_execute_more: "შეუძლებელია მეტი {0} მოთამაშის დასჯა (ცოცხალი: {1}).",
      three_way_tie_rule: "წესი 3-ს 9-ზე",
      cannot_execute_three_way_tie: "FIIM-ის წესებით 9 მოთამაშის შემთხვევაში 3 კანდიდატის სიკვდილით დასჯა აკრძალულია.",
      select_action: "აარჩიეთ მოქმედება:",
      current_results: "მიმდინარე შედეგები:",
      // Penalty section
      penalty_section: "საკ. {0}",
      foul_four_heading: "საჯარიმო 4-ე ფოლზე:",
      foul_four_instructions:
        "საჭიროა გადაწყვეტილების მიღება მოთამაშესთან დაკავშირებით.",
      foul_three_heading: "საჯარიმო 3-ე ფოლზე:",
      foul_three_instructions:
        "აარჩიეთ რომელი დღეს გამოტოვებს მოთამაშე სიტყვას.",
      // Stream settings
      stream_settings: "ტრანსლაციის პარამეტრები",
      stream_theme_label: "გრაფიკული გაფორმება",
      stream_language_label: "ტრანსლაციის ენა",
      theme_classic: "კლასიკური",
      theme_dark: "ბნელი",
      theme_noroles: "როლების გარეშე",
      theme_cartel: "Cartel",
      theme_xcity: "X-City",
      settings_button: "პარამეტრები",
      app_language_label: "აპის ენა"
    },
  },
  // Hebrew dictionary (index 4)
  {
    ph: {
      registration: "רישום מהיר",
      total:"סה״כ",
      create: "צור",
      event_o: "אירועים פעילים",
      event_p: "אירועים קודמים",
      event_c: "צור אירוע חדש",
      event_t: "הזן שם (ערב משחקים/מיני קאפ)",
      prtcp: "משתתפים",
      gamescaps: "משחקים",
      gamecaps: "משחק",
      event_pa: "דף האירוע",
      killed: "נרצח",
      in: "במקום",
      reopen: "לפתוח מחדש",
      games: "משחקים",
      cgname: "משחק",
      copylink: "העתק",
      startclub: "התחל משחק חדש",
      pwarning:
                  "אתה לא שופט בטורניר זה - כל השינויים לא יישלחו לשרת!",
      swarning:
                  "האם אתה בטוח שברצונך לשלוח את השינויים לשרת? מסך הנתונים שהוזנו ייסגר. לידיעתך, לאחר שליחת התוצאות בהצלחה, תועבר אוטומטית למסך הראשי!",
      rwarning:
                  "אתה מנסה לעדכן את המשחק - זה רק עדכון של תוספות, עונשים והערות. אם אתה צריך לעדכן משהו אחר, אנא הזן מחדש את כל המשחק כולו!",
      stage: "שלב",
      start: "התחל",
      delete: "מחק",
      table: "שולחן",
      session: "סיבוב",
      back: "→ חזרה",
      noseats:
          "ההושבה עדיין לא נוצרה או שהטורניר כבר נסגר.",
      none: "אין",
      voting: "הצבעה",
      cselerror:
          "עליכם לבחור מועדון כדי לנהל את המשחק. האם אתם בטוחים שהמועדון שלכם נתמך על ידי המערכת? נסו לסנכרן את הנתונים.",
      dph: "שלב יום",
      nph: "שלב לילה",
      resph: "תוצאות",
      sclub: "המועדונים שלך",
      players: "שחקנים",
      citydec: "החלטת העיר",
      execall: "להוציא להורג את כולם",
      vanga: "מנחש את המאפיה",
      lms: "אומר צוואה",
      skip: "לדלג",
      confirm: "לאשר",
      plgot4f: "השחקן קיבל 4 עבירות",
      rcnt: "איפוס עבירות",
      plgot3f: "השחקן קיבל עבירה שלישית ולא ידבר",
      tday: "היום הזה",
      nday: "היום הבא",
      novoting: "שחקן אחד הוצא, בעיר לילה",
      bye1player: "שחקן אחד הוצא, השחקן",
      bye1player2: "עוזב את המשחק",
      exec: "להוציא להורג",
      mmenu: "תפריט ראשי",
      logout: "יציאה",
      close: "סגור",
      morning: "בוקר",
      btday: "ליום קודם",
      cancelgame: "לבטל את המשחק",
      ppk: "ניצחון של הקבוצה היריבה",
      disqualify: "הרחק שחקן",
      ppkred: "השלום ניצח בזכות השחקן מספר:",
      ppkblack: "המאפיה ניצחה בזכות השחקן מספר:",
      chooseact: "פעולות",
      loadall: "טען את כל הטורנירים",
      roles: "תפקידים",
      hroles: "הסתר תפקידים",
      gngt: "עבור ללילה",
      confirm_cancel_game: "לאשר ביטול משחק?",
      confirm_cancel_game_message: "האם אתה בטוח שברצונך לבטל את המשחק? כל ההתקדמות תאבד.",
      confirm_go_night: "לאשר מעבר ללילה?",
      confirm_go_night_message: "האם אתה בטוח שברצונך לעבור ללילה בלי הצבעה? שלב ההצבעה ידולג.",
      confirm_back_to_day: "לאשר חזרה ליום?",
      confirm_back_to_day_message: "האם אתה בטוח שברצונך לחזור לשלב היום? התקדמות שלב הלילה תאבד.",
      yes_cancel: "כן, בטל",
      yes_proceed: "כן, המשך",
      yes_return: "כן, חזור",
      disqualification_warning_title: "אזהרת הרחקה",
      disqualification_warning_message: "על פי כללי המשחק, ההצבעה היום צריכה להתבטל בגלל הרחקת שחקן בשלב הנוכחי או הקודם.",
      skip_voting_go_night: "עבור ללילה",
      vote_anyway: "הצבע בכל זאת",
      fls: "עבירות",
      sroles: "הצג תפקידים",
      upnow: "העלה עכשיו",
      save: "שמור",
      don: "דון",
      maf: "מאפיה",
      shrf: "שריף",
      fblood: "הקורבן הראשון",
      lh: "מהלך הטוב ביותר",
      na: "לא רלוונטי",
      lorder: "סדר עזיבה",
      otstr: "ירי",
      donchk: "חקירות דון",
      shchk: "חקירות שריף",
      logedas: "נכנסת כ ",
      ctwon: "ניצחון העיירה",
      mafwon: "המאפיה ניצחה ",
      draw: "תיקו",
      upfail: "ההעלאה נכשלה, הנתונים נשמרו, אנא נסה שוב",
      plsactivate:
          "אנא הפעל את חשבונך באמצעות דוא״ל והיכנס למערכת",
      player: "שחקן",
      isdup: "כפיל",
      pwd: "סיסמה",
      cncl: "ביטול",
      nxt: "הבא",
      srch: "חיפוש",
      nrate: "ללא דירוג",
      yrate: "עם דירוג",
      rdy: "מוכן",
      pwlength: "הסיסמה חייבת להכיל 3–100 תווים",
      header: " Mafia App",
      submit: "שלח",
      login: "כניסה",
      loading: "טוען",
      adding_players: "סידור השחקנים",
      intro_n: "חלוקת הקלפים והסכם",
      juComment: "תיאור הבונוסים והעונשים",
      juCommentDef: "המידע לא מולא",
      juError:
          "השופט לא מונה לשולחן באתר, תקן זאת ונסה שוב!",
      j: "שופט",
      g_a: "דפ",
      g_p: "שטר",
      g_dp: "דיסק.ש.",
      restoreGameMsg: "להמשיך במשחק שלא הושלם?",
      toggle_timer: "להפעיל את הטיימר",
      reset_timer: "לאפס את הטיימר",
      technical_break: "הפסקה טכנית",
      technical_break_title: "הפסקה טכנית",
      technical_break_message: "המשחק בהפסקה טכנית. סגור את החלון הזה כדי להמשיך.",
      stream_connection_error: "שגיאת רשת: בדוק את החיבור לאינטרנט. השידור עשוי שלא להתעדכן.",
      // דף כניסה
      welcome_subtitle: "ברוך הבא לממשק ניהול המשחקים של Mafia World Tour",
      email_label: "דוא״ל",
      email_placeholder: "you@example.com",
      password_placeholder: "••••••••",
      choose_language: "בחר שפה",
      lang_english: "English",
      lang_russian: "Русский",
      lang_ukrainian: "Українська",
      lang_georgian: "ქართული",
      lang_hebrew: "עברית",
      login_meta: "השתמש בנתוני הכניסה שלך ל-Mafia World Tour כדי להיכנס.",
      login_failed: "שגיאה בכניסה",
      network_error: "שגיאת רשת",
      // מילות אחרונות
      last_words: "נאום פרידה",
      voted_out: "הודח על ידי העיר",
      eliminated_night: "נהרג בלילה",
      final_speech: "יש לו אפשרות לשאת נאום אחרון לפני שיוצא מהמשחק.",
      player_of: "השחקן {0} מ{1}",
      instructions: "הוראות:",
      allow_speech: "אפשר לשחקן שהומת לשאת נאום אחרון",
      share_thoughts: " השחקן יכול לשתף את מחשבותיו, חשדותיו או האסטרטגיה שלו",
      click_continue: "לחץ על \"{0}\" כאשר הנאום יסתיים",
      multiple_eliminated: "מספר שחקנים הודחו - כל אחד מקבל תור",
      goodbye: "להתראות",
      undo_vote: "ביטול",
      back_to_night: "חזרה ללילה",
      continue_game: "המשך המשחק",
      next_player: "השחקן הבא",
      // Role Assignment
      citizens: "אזרחים",
      citizen: "אזרח",
      mafia: "מאפיה",
      instructions_roles: "לחץ על סמלי התפקידים כדי לשנות את תפקידי השחקנים",
      required_roles: "נדרש: 6 אזרחים, 2 מאפיה, 1 דון, 1 שריף",
      hide_roles_instruction: "השתמש בלחצן \"הסתר תפקידים\" כדי להסתיר את חלוקת התפקידים מהשחקנים",
      click_ready: "לחץ על \"מוכן\" כאשר כל התפקידים חולקו כהלכה",
      invalid_distribution: "חלוקת תפקידים שגויה!",
      current_distribution: "נוכחי: {0} אזרחים, {1} מאפיה, {2} דון, {3} שריף",
      // מקומות בטורניר
      loading_seats: "טוען את מקומות הישיבה בטורניר...",
      tournament_seating: "מקומות הישיבה בטורניר",
      select_session: "בחר סשן למשחק",
      no_seats_available: "מקומות הישיבה אינם זמינים",
      failed_load_seats: "לא ניתן לטעון את מקומות הישיבה בטורניר",
      seats_not_generated: "מקומות הישיבה עדיין לא נוצרו או שהטורניר כבר נסגר.",
      // תוצאות המשחק
      game_in_progress: "המשחק בעיצומו",
      search_judge: "חיפוש שופט...",
      game_description: "תיאור המשחק...",
      search_penalties: "חיפוש עונשים...",
      judge_label: "שופט",
      description_label: "תיאור",
      penalty_value: "עונש: {0}",
      game_statistics: "סטטיסטיקת המשחק",
      game_timing: "זמן המשחק",
      start_time: "התחלה",
      end_time: "סיום",
      nights_count: "לילות",
      // תפריט ראשי
      mafia_app: "אפליקציית המאפיה",
      refresh: "רענן",
      select_club: "בחר מועדון",
      tournament_region_flag: "דגל אזור הטורניר",
      main_menu_subtitle: "בחר מועדון או טורניר כדי לנהל את המשחק הבא.",
      club_section_description: "עבור לאירועי המועדון והפעל משחק חדש.",
      club_card_meta: "ניהול אירועים ומשחקים",
      open_club: "פתח אירועים",
      no_clubs_synced: "המועדונים עדיין לא סונכרנו. רענן את הדף או בדוק את זכויות הגישה.",
      tournaments_heading: "טורנירים",
      tournament_section_description: "עיין באירועים הרשמיים ופתח את סידור הישיבה לשולחן שלך.",
      tournament_card_meta: "לחץ כדי לראות את מקומות הישיבה והמשתתפים",
      view_seats: "פתח את מקומות הישיבה",
      no_tournaments: "אין טורנירים זמינים כרגע. רענן מאוחר יותר כדי לסנכרן אירועים.",
      profile_title: "פרופיל",
      profile_aria_label: "פרופיל",
      club_logo_alt: "לוגו {0}",
      // פעולות משחק
      select_disqualify: "בחר שחקן להרחקה",
      select_ppk: "בחר שחקן שגרם לניצחון הקבוצה היריבה:",
      action_label: "פעולה:",
      note_label: "הערה:",
      ppk_note:
        "PPK (ניצחון הקבוצה היריבה) משמש כאשר פעולות השחקן מובילות ישירות להפסד קבוצתו. הקבוצה היריבה מוכרזת כמנצחת.",
      // Player Setup
      add_guest: "הוספת אורח",
      judge_avatar_alt: "אאווטאר השופט",
      player_avatar_alt: "אאווטאר {0}",
      guest_player_label: "אורח {0}",
      level_short: "רמה {0}",
      // שלב היום
      first_day: "היום הראשון",
      day_number: "יום {0}",
      first_speaker: "הדובר הראשון:",
      nomination_order: "סדר העמדה להדחה: {0}",
      nomination_title: "שחקן {0} מעמיד להדחה",
      nomination_prompt: "בחר שחקן להעמדה להדחה",
      player_eliminated_tooltip: "השחקן {0} הודח",
      player_already_nominated: "השחקן {0} כבר הועמד",
      nominate_player: "העמד את השחקן {0}",
      current_nomination: "העמדה נוכחית: השחקן {0}",
      clear_nomination: "בטל את ההעמדה",
      unknown: "לא ידוע",
      vs: "VS",
      day_instructions_title: "הוראות לשלב היום",
      day_instruction_discuss: "השחקנים דנים ומציעים מועמדים",
      day_instruction_vs: "השתמש בכפתור VS כדי להציע שחקן להצבעה",
      day_instruction_disabled: "שחקנים שהודחו ושחקנים שכבר הועמדו להצבעה אינם זמינים",
      day_instruction_fouls: "לחץ על סמלי העבירות כדי להטיל עונשים",
      day_instruction_voting: "התחל בהצבעה כאשר ההצבעות מוכנות",
      day_instruction_skip: "השתמש ב'בלילה' כדי לעבור ישירות לשלב הלילי",
      current_nominations_title: "העמדות להדחה",
      nomination_item: "{0} מעמיד את {1}",
      // אירועי מועדון
      enter_event_title: "אנא הזן את שם האירוע",
      failed_create_event: "לא ניתן ליצור את האירוע",
      confirm_remove_participant: "האם אתה בטוח שברצונך להסיר את המשתתף הזה?",
      loading_participants: "טוען משתתפים...",
      actions: "פעולות",
      confirm_delete_game: "האם אתה בטוח שברצונך למחוק את המשחק הזה?",
      confirm_close_event: "האם אתה בטוח שברצונך לסגור את האירוע הזה?",
      confirm_open_event: "האם אתה בטוח שברצונך לפתוח מחדש את האירוע הזה?",
      confirm_delete_event: "האם אתה בטוח שברצונך למחוק את האירוע הזה?",
      event_ranking: "דירוג האירוע",
      failed_update_event_ranking: "לא ניתן לעדכן את דירוג האירוע",
      event_title_label: "שם",
      event_date_label: "תאריך",
      event_time_label: "שעה",
      event_description_label: "תיאור (לא חובה)",
      event_description_placeholder: "תיאור האירוע...",
      event_exists_warning: "כבר קיים אירוע בתאריך זה. האם ברצונך ליצור עוד אחד?",
      creating: "יצירה...",
      club_prefix: "מועדון: {0}",
      more_events: "... (עוד {0})",
      yes: "כן",
      no: "לא",
      // פעולות לילה
      select_shooting_target: "בחר מטרה לירי לילי:",
      miss: "החטאה",
      don_dead_skip: "דון מת - הבדיקה מדלגת",
      select_don_check: "בחר שחקן לחקירת הדון:",
      next: "הבא ←",
      sheriff_dead_skip: "השריף מת - הבדיקה מדלגת",
      select_sheriff_check: "בחר שחקן לבדיקת השריף:" ,
      check_player: "בדוק את השחקן {0}",
      player_dead: "השחקן {0} מת",
      step_shooting: "ירי",
      step_don: "דון",
      step_sheriff: "שריף",
      stage_1_shooting: "שלב 1: ירי לילי",
      stage_2_don: "שלב 2: חקירת הדון",
      stage_3_sheriff: "שלב 3: חקירת השריף",
      // מעבר לבוקר
      no_night_eliminations: "אף אחד לא נהרג הלילה.",
      continue_to_day: "המשך ליום",
      continue_to_day_number: "המשך ליום {0}",
      first_victim_note: "הקורבן הראשון — יכול לנקוב בשם המאפיה",
      select_mafia_prompt: "בחר עד 3 שחקנים שאתה חושב שהם מהמאפיה:",
      last_words_note: "נאום פרידה לפני היציאה מהמשחק",
      best_move_unavailable: "המהלך הטוב ביותר אינו זמין:",
      first_day_eliminations: "ביום הראשון הודחו {0} שחקנים",
      // Voting
      no_nominations_title: "אין מועמדים",
      no_nominations_desc: "אף שחקן לא הועמד להצבעה.",
      single_nomination: "מועמד אחד בלבד: {0}",
      player_will_be_eliminated: "{0} יוחרם.",
      tie_repeat_info:
        "לאחר הצבעה חוזרת, מספר השחקנים עם מספר קולות שווה לא השתנה.",
      tie_exceeds_limit_warning: "הוצאתם להורג של כל {0} השחקנים חורגת מהמגבלה!",
      tie_execute_tooltip: "להוציא להורג את כל {0} השחקנים",
      tie_execute_limit_tooltip: "לא ניתן להוציא להורג {0} שחקנים (הגבלה: {1})",
      shootout_round: "קרב יריות {0}",
      candidate_progress: "המועמד {0} מתוך {1} | נותרו קולות: {2}",
      candidate_receives_remaining:
        "השחקן #{0} מקבל את כל הקולות הנותרים: {1}",
      finish_voting: "סיים את ההצבעה",
      all_remaining_votes: "כל הקולות הנותרים",
      tied_players: "שחקנים עם מספר קולות שווה:",
      rule_50_percent: "כלל 50%:",
      cannot_execute_more: "לא ניתן להוציא להורג יותר מ-{0} שחקנים (50% מ-{1} השחקנים החיים).",
      three_way_tie_rule: "כלל 3 מתוך 9",
      cannot_execute_three_way_tie: "על פי כללי המשחק, לא ניתן להוציא להורג את כל 3 השחקנים כאשר יש בדיוק 9 שחקנים חיים והקולות מתחלקים בין 3 מועמדים. עליך לבטל את ההצבעה או לעבור ללילה.",
      select_action: "בחר פעולה:",
      current_results: "תוצאות נוכחיות:",
      // סעיף עונשים
      penalty_section: "סעיף {0}",
      foul_four_heading: "עונש על עבירה 4:",
      foul_four_instructions:
        "יש להחליט מה לעשות עם השחקן.",
      foul_three_heading: "עונש על עבירה שלישית:",
      foul_three_instructions:
        "בחר באיזה יום השחקן יחמיץ את הנאום.",
      // Stream settings
      stream_settings: "הגדרות שידור",
      stream_theme_label: "ערכת עיצוב לשידור",
      stream_language_label: "שפת שידור",
      theme_classic: "קלאסי",
      theme_dark: "כהה",
      theme_noroles: "ללא תפקידים",
      theme_cartel: "קרטל",
      theme_xcity: "איקס-סיטי",
      settings_button: "הגדרות",
      app_language_label: "שפת האפליקציה",
    },
  },
];

export const getGameStageNames = (language: number): string[] => {
  // Fallback to English if language index is out of bounds
  const lang = language < dictionaries.length ? language : 0;
  return [
    dictionaries[lang].ph.loading,
    dictionaries[lang].ph.adding_players,
    dictionaries[lang].ph.intro_n,
    dictionaries[lang].ph.dph,
    dictionaries[lang].ph.nph,
    dictionaries[lang].ph.resph,
  ];
};

export const gameRoles = ["none", "red", "black", "don", "sheriff"];

export const formatTime = (time: any) => {
  for (const key in time) {
    if (key === "mils") {
      if (time[key] < 1) {
        time[key] = "000";
      } else {
        if (time[key] < 10) {
          time[key] = "00" + time[key];
        } else if (time[key] < 100) {
          time[key] = "0" + time[key];
        }
      }
    } else if (time[key] < 10) {
      time[key] = "0" + time[key];
    }
  }
  return time;
};

export const milToTime = (mil: number) => {
  const mi = mil % 1000;
  const seconds = parseInt((mil / 1000).toString()) % 60;
  const minutes = parseInt((mil / 1000 / 60).toString()) % 60;
  const hours = parseInt((mil / 1000 / 3600).toString());
  return {
    s: seconds,
    m: minutes,
    h: hours,
    mils: mi,
  };
};
